module.exports = __webpack_public_path__ + "img/Video.115b2f60.jpg";